<template>
  <div>
    <loading :loading="!pontos" />
    <md-steppers
      v-if="pontos"
      ref="mdSteppers"
      md-vertical
      md-dynamic-height
      @md-changed="cancelDoneSteppers"
    >
      <md-step
        v-for="(ponto, index) in pontos"
        :id="index.toString()"
        :ref="'step' + index"
        :key="new Date(ponto.horarioCriacao).valueOf()"
        :md-done="false"
        :md-label="'Criado por ' + ponto.usuarioNome"
        :md-description="
          new Date(ponto.horarioCriacao)
            .utcToLocalDate()
            .toLocaleDateString('pt-BR')
        "
      >
        <md-button
          class="md-primary md-raised"
          @click.stop="() => createOpenFotosTab(ponto.fotos)"
        >
          Fotos
        </md-button>
        <li
          v-for="([array, data], i) in objectToTuple(ponto.dadosAssociados)"
          :key="i"
        >
          {{ compositeName(array) }}: <b>{{ data }}</b>
        </li>
      </md-step>
    </md-steppers>
    <slider-right ref="sliderHistorico">
      <listagem-fotos-sig :fotos="fotosExibicao" />
    </slider-right>
  </div>
</template>

<script>
import http from '../../../utils/http'
import Loading from '../../Loading'
import SliderRight from '../../SliderLeft'
import ListagemFotosSig from '../ListagemFotosSig'

export default {
  name: 'HistoricoPontosSig',
  components: { ListagemFotosSig, SliderRight, Loading },
  props: {
    pontoId: String,
  },
  data() {
    return {
      pontos: null,
      fotosExibicao: [],
    }
  },
  async mounted() {
    this.pontos = (await http.get(`ponto-sig/${this.pontoId}/historico`)).pontos

    this.$nextTick(() => {
      const itens = Object.keys(this.$refs.mdSteppers.MdSteppers.items)

      itens.forEach((e) => {
        this.$refs[
          'step' + e
        ][0].$el.children[0].children[0].children[0].children[0].innerHTML = (
          itens.length - +e
        ).toString()
      })
    })
  },
  methods: {
    objectToTuple(obj) {
      return Object.keys(obj).map((e) => [e.split(/(?=[A-Z])/g), obj[e]])
    },
    compositeName(array) {
      array[0] = array[0].charAt(0).toUpperCase() + array[0].slice(1)
      return array.join(' ')
    },
    cancelDoneSteppers() {
      const itens = Object.keys(this.$refs.mdSteppers.MdSteppers.items)
      itens.forEach((e) => {
        const item = this.$refs.mdSteppers.MdSteppers.items[e]
        item.done = false
      })
    },
    async createOpenFotosTab(fotos) {
      this.fotosExibicao = fotos
      await this.$refs.sliderHistorico.toogleTab()
    },
  },
}
</script>

<style scoped></style>
